<template>
    <form-item-wrapper :widget="widget" :formData="formData" ref="itemref">
        <a-radio-group v-model:value="formData[widget.name]" :name="widget.name" :disabled="widget.options.disabled"
            :placeholder="widget.options.placeholder" :optionType="widget.options.optionType"
            :buttonStyle="widget.options.buttonStyle" :options="widget.options.optionItems" @change="handleOnChange">
        </a-radio-group>
    </form-item-wrapper>
</template>

<script setup>
import FormItemWrapper from "./form-item-wrapper.vue";
import { ref, toRefs } from 'vue';
import useEvent from "./useEvent";

const props = defineProps({
    widget: Object,
    formData: Object,
})
const { widget, formData } = toRefs(props)
const itemref = ref(null)

const {
    handleOnChange,
} = useEvent(widget.value, itemref, formData.value);
</script>